// extracted by mini-css-extract-plugin
var _1 = "EpostFormFieldsRadioLabel-moduletext__tS9lz";
export { _1 as "text" }
